export * from './vorlagen-list.component';
export * from './vorlagen-list.component.module';